/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

import { FOLDERS } from "../doseeData/utils/Utils";
import { useAdminContext } from "../../context/admin/AdminContext";
import { getOneCompany } from "../../lib/sysNavigation/SysNavigation";
import { ImageKitUpload } from "../../ui/ImageKitLibrary";
import { useCountryContext } from "../../context/CountryContext";
import {
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  AddPageShell,
  AddSection,
  SearchSelectInput,
} from "../components/Component";
import { FiInfo, FiImage, FiUser, FiGlobe } from "react-icons/fi";

const Edit = () => {
  const { updateBySuperAdmin } = useAdminContext();
  const { countries, fetchCountries } = useCountryContext();

  const company: any = getOneCompany();
  const company_id = company?.company_id;

  const [error, setError] = useState<any>(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>(null);

  const admin = company?.Admins?.length > 0 ? company?.Admins[0] : null;

  const [firstName, setFirstName] = useState<any>(admin?.first_name);
  const [lastName, setLastName] = useState<any>(admin?.last_name);
  const [password, setPassword] = useState<any>(null);
  const [email, setEmail] = useState<any>(admin?.email);
  const [phoneNumber, setPhoneNumber] = useState<any>(admin?.phonenumber);

  const [name, setName] = useState<any>(company?.name);
  const [country, setCountry] = useState<any>(company?.country);
  const [website, setWebsite] = useState<any>(company?.website);
  const [thumbnail, setThumbnail] = useState<any>(company?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(company?.image_cdn_id);
  const [description, setDescription] = useState<any>(company?.description);

  const companyRoutes = "/company";

  const responses = (isError: any, success: any, message: any) => {
    setLoading(false);
    setError(isError);
    setSuccess(success);
    setErrorMessage(message);
  };

  useEffect(() => {
    if (!countries) fetchCountries();
  }, [countries, country]);

  const isValid = ({ data, value, key }: any) => {
    return data?.find((x: any) => (x?.[key] === value ? true : false));
  };

  const addOneCompanyHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, false, "Image Required");
    } else if (!isValid({ data: countries, value: country, key: "name" })) {
      responses(true, false, "Invalid Country");
    } else await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      admin_id: admin?.admin_id,
      name: name,
      thumbnail: thumbnail,
      image_cdn_id: thumbnailId,
      description: description,
      website: website,
      email: email,
      first_name: firstName,
      last_name: lastName,
      password: password && password !== "" ? password : null,
      phonenumber: phoneNumber,
      country: country,
    };

    const { message, status } = await updateBySuperAdmin(company_id, data);

    if (status === 200 || status === 201) {
      setLoading(false);
      setSuccess(true);
      responses(false, true, message);
    } else {
      responses(true, false, message);
    }
  };

  const clearMessages = () => {
    setError(null);
    setSuccess(null);
  };

  return (
    <AddPageShell
      backRoute={companyRoutes}
      eyebrow="Settings • About"
      title="Edit About Page"
      subtitle="Update brand assets, company details and admin information."
      icon={<FiInfo className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={addOneCompanyHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage(null);
          }}
        />
      }
    >
      <AddSection
        title="Brand Assets"
        hint="JPEG/PNG, square preferred."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={FOLDERS.COMPANY}
        />
      </AddSection>

      <AddSection
        title="Company Details"
        hint="Public company information."
        icon={<FiGlobe className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "Name",
              title: "Company Name",
              type: "text",
              value: name ? name : "",
              onChange: (e: any) => {
                setName(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "Website",
              title: "Company Website",
              type: "text",
              value: website ? website : "",
              onChange: (e: any) => {
                setWebsite(e.target.value);
                clearMessages();
              },
            }}
          />
          <SearchSelectInput
            title="Country"
            value={country ? country : null}
            options={countries ? countries?.map((x: any) => x?.name) : []}
            onChange={(val: any) => setCountry(val)}
          />
        </div>
        <div className="mt-4">
          <TextArea
            props={{
              id: "description",
              title: "Description",
              type: "text",
              value: description ? description : "",
              onChange: (e: any) => {
                setDescription(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Admin Info"
        hint="Primary admin contact for this company."
        icon={<FiUser className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "FirstName",
              title: "First Name",
              type: "text",
              value: firstName ? firstName : "",
              onChange: (e: any) => {
                setFirstName(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "LastName",
              title: "Last Name",
              type: "text",
              value: lastName ? lastName : "",
              onChange: (e: any) => {
                setLastName(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "Email",
              title: "Email Address",
              type: "text",
              value: email ? email : "",
              onChange: (e: any) => {
                setEmail(e.target.value);
                clearMessages();
              },
            }}
          />
          <PhoneInput
            setPhone={setPhoneNumber}
            phone={phoneNumber}
            required={false}
            country={country}
          />
          <InputField
            props={{
              id: "Password",
              title: "Password",
              type: "password",
              value: password ? password : "",
              onChange: (e: any) => {
                setPassword(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
